{
  "completed": "Avslutad: ",
  "current": "Nuvarande: ",
  "notCompleted": "Ej genomförd: ",
  "steplist": "Steglista"
}
